<template>
  <div class="app-container crm-follow-list">
    <el-form :model="queryParams" ref="queryForm" class="multipleSelectScroll" v-show="showSearch" label-width="100px">
      <el-row :gutter="10" class="mb8">
        <dept-user-select ref="deptUserSelectRef" :formParam="queryParams" :user-label="'员工姓名'" :user-id-field="'userIdList'" :auto-select-user="false"></dept-user-select>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="年份" prop="targetTime">
            <el-date-picker
              v-model="queryParams.targetTime"
              value-format="yyyy"
              type="year"
              placeholder="请选择"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :md="12" :lg="6" :offset="18" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>
    <el-row class="mb8">
      <el-col :xs="24" :md="12" :lg="6" align="left">
        <el-button type="primary" @click="handleAdd">添加目标</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="员工姓名" width="100" align="center" prop="nickName" />
      <el-table-column label="部门" align="center" prop="deptName"></el-table-column>
      <el-table-column
        label="年份"
        min-width="100"
        align="center"
        prop="targetTime"
        show-overflow-tooltip
      >
        <template slot-scope="scope">{{scope.row.targetTime}}年</template>
      </el-table-column>
      <el-table-column label="签约目标(元)" align="center" prop="signTargetAmount" show-overflow-tooltip>
        <template slot-scope="scope">{{amountFormat(scope.row.signTargetAmount/10000)}}万</template>
      </el-table-column>
      <el-table-column label="回款目标(元)" align="center" prop="fundTargetAmount">
        <template slot-scope="scope">{{amountFormat(scope.row.fundTargetAmount/10000)}}万</template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="100"
        align="center"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
    <AddTargetDialog ref="targetDialogRef" @success="getList"></AddTargetDialog>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {delteKpi, listByPage} from "@/api/crm/kpi";
import {amountFormat} from "@/utils/index";
import AddTargetDialog from "@/views/crm/kpi/addTargetDialog";
import deptUserSelect from "@/views/crm/components/deptUserSelect";

export default {
  name: "FollowManage",
  data() {
    return {
      amountFormat,
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      dataList: [],
      deptOptions: [],
      userOptions: [],
      targetTypeOptions: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        deptIdList: [],
        userIdList: [],
        targetTime: null
      }
    };
  },
  computed: {
    ...mapState({
      currentUser: state => state.user,
      dept: state => state.user.dept,
      userDataScope: state => state.user.userDataScope
    })
  },
  components: {
    AddTargetDialog,
    deptUserSelect
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      let params = JSON.parse(JSON.stringify(this.queryParams));
      if (params.createTime && params.createTime.length > 1) {
        params.startDate = params.createTime[0];
        params.endDate = params.createTime[1];
      }
      params.createTime = undefined;
      listByPage(params)
        .then(response => {
          this.dataList = response.rows;
          this.total = response.total;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 新增目标
    handleAdd() {
      this.$refs.targetDialogRef.open();
    },
    handleEdit(item) {
      this.$refs.targetDialogRef.open(item);

    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    handleDelete(row) {
      let that = this;
      that
        .$confirm("确认删除该数据？", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          delteKpi({
            id: row.id
          })
            .then(response => {
              that.getList();
            })
            .catch(error => {
              this.loading = false;
            });
        });
    }
  }
};
</script>

<style lang='scss'>
.crm-follow-list {
  .content {
    word-break: break-all;
    line-height: 1.5em;
  }
}
</style>
